import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
// Gutwin Shared Library
import { OfflineService } from 'gutwin-shared';

@Injectable()
export class OfflineChildGuard implements CanActivateChild {

  constructor(private offlineService: OfflineService, private router: Router) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.offlineService.online) {
      return true;
    }

    this.router.navigate(['audits']);
    return false;
  }

}
